import BulkOrderCompletePage from '../../../customer/components/pages/bulk_order/BulkOrderCompletePage.vue'

export default {
  components: { BulkOrderCompletePage }
}
